import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { TRANSLATION } from '../constants'
import { BannerMobile } from './BannerMobile'
import * as Styles from './styles'

export const BannerInfo = () => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()

  const items = [
    i18n.t(`${TRANSLATION}.banner.one`),
    i18n.t(`${TRANSLATION}.banner.two`),
    i18n.t(`${TRANSLATION}.banner.three`),
  ]

  if (isPhone) {
    return <BannerMobile items={items} />
  }

  return (
    <Styles.Container>
      {items.map((item, index) => (
        <Styles.Item key={index}>
          <Styles.Icon />
          <Styles.Title dangerouslySetInnerHTML={{ __html: item }} />
        </Styles.Item>
      ))}
    </Styles.Container>
  )
}
